import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";

// list -------------------------------------------------------------
const list = async (date) => {
    let queryParam = '?date=' + date;
    return await axios({
        url: getmainurl() + '/api/v1/venues' + queryParam, method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const getActivatedVenue = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/venues/activated', method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const deactivate = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/venues/deactivate', method: 'post', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const activate = async (data) => {
    return await axios({
        url: getmainurl() + '/api/v1/venues/activate', method: 'post', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const listAll = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/venues', method: 'get', headers: authHeader()
    }).then(response => {
        if (response.status!==200) {
            console.log(response.status, response.statusText, response.data);
            return [];
        } else {
            return response.data;
        }
    }).catch(function (error) {
        console.log(error.response.data);
        return [];
    })
}

const save = async (data) => {
    return await axios({
        url: getmainurl() + '/api/v1/venues', method: 'post', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

// create / update / remove : errors are rethrown so the caller can display them
const errorMessage = (error) =>
    error?.response?.data?.message
    || error?.response?.data?.errors?.map(e => e.msg).join(', ')
    || error?.message
    || 'An error occurs';

const create = async (data) => {
    return axios({
        url: getmainurl() + '/api/v1/venues', method: 'post', headers: authHeader(), data: data
    }).then(response => response.data)
    .catch(error => { throw new Error(errorMessage(error)); });
}

const update = async (uuid, data) => {
    return axios({
        url: getmainurl() + '/api/v1/venues/' + uuid, method: 'put', headers: authHeader(), data: data
    }).then(response => response.data)
    .catch(error => { throw new Error(errorMessage(error)); });
}

const remove = async (uuid) => {
    return axios({
        url: getmainurl() + '/api/v1/venues/' + uuid, method: 'delete', headers: authHeader()
    }).then(response => response.data)
    .catch(error => { throw new Error(errorMessage(error)); });
}

const importVenues = async (venues) => {
    return axios({
        url: getmainurl() + '/api/v1/venues/import', method: 'post', headers: authHeader(), data: {venues}
    }).then(response => response.data)
    .catch(error => { throw new Error(errorMessage(error)); });
}

// default export ---------------------------------------------------
const venue = {
    activate,
    deactivate,
    list,
    listAll,
    getActivatedVenue,
    save,
    create,
    update,
    remove,
    importVenues,
};

export default venue;